module.exports = __webpack_public_path__ + "static/sense-banner.5ccde850.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/sense-banner.png
// module id = 1036
// module chunks = 2